import {useFormatCurrency} from 'platform/locale';

import {useCallback} from 'react';

import {isNil} from 'ramda';

import {PriceReportType} from '../../../types/PriceReportType';

const EMPTY_VALUE = '–';

/**
 * Formats a price in the report currency for panel cells. Single place to switch
 * to a compact notation (e.g. “245 k”) if the full format proves too wide.
 */
export function useFormatPanelPrice(
  priceReport: PriceReportType
): (price: number | null) => string {
  const formatCurrency = useFormatCurrency();
  const currency = priceReport.sellingPrice.recommended.currency;

  return useCallback(
    (price: number | null) => {
      if (isNil(price)) {
        return EMPTY_VALUE;
      }
      return formatCurrency(price, currency) ?? EMPTY_VALUE;
    },
    [formatCurrency, currency]
  );
}
